import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function HeroCTA() {
  const { t } = useTranslation("heropage");

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 3, md: 8 },
        py: { xs: 6, md: 12 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, md: 5 },
      }}
    >
      {/* Main Statement */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <Typography
          sx={{
            fontFamily: "'Playfair Display', 'Cormorant Garamond', serif",
            fontSize: { xs: "2rem", md: "4rem" },
            fontWeight: 700,
            color: "#111",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          {t("cta.headline")}
        </Typography>
      </motion.div>

      {/* Services Breakdown */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2, delay: 0.8, ease: "easeOut" }}
        style={{ maxWidth: 900 }}
      >
        <Typography
          sx={{
            fontFamily: "'Lora', serif",
            fontSize: { xs: "1rem", md: "1.25rem" },
            fontWeight: 400,
            color: "#555",
            textAlign: "center",
            lineHeight: 1.8,
          }}
        >
          {t("cta.description")}
        </Typography>
      </motion.div>

      {/* Subtle floating animation overlay */}
      <motion.div
        animate={{
          y: ["0%", "-2%", "0%"],
          x: ["0%", "10%", "-10%", "0%"],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{ width: "100%" }}
      >
        {/* Decorative underline */}
        <Box
          sx={{
            height: 2,
            width: "50%",
            backgroundColor: "#C6A972",
            borderRadius: 1,
            mt: 4,
            mx: "auto",
          }}
        />
      </motion.div>
    </Box>
  );
}
